import {useFormik} from "formik";
import {useEffect, useState} from "react";
import {CoreService} from "../../../services/core.service";
import {ApiOrderInterface, ApiPhotoOrderInterface} from "../../../interfaces/entity";
import useToastifyHook from "../../../hooks/useToastifyHook";
import translate from "../../../utils/translate";

interface Interface {
    close: () => void;
    setLoading: (value: boolean) => void;
}

const useCreatePhotoReport = ({close, setLoading}: Interface) => {

    const coreService = new CoreService()

    const toast = useToastifyHook();

    const [order, setOrder] = useState<ApiOrderInterface>(null)
    const [photosFormOrder, setPhotosFromServer] = useState<ApiPhotoOrderInterface[]>([])
    const [photoUploadForm, setPhotoUploadForm] = useState<{ id: string, name: string, blob: Blob }[]>([])

    const formik = useFormik({
        initialValues: {
            number: '',
            selectedOrder: null,

        },
        onSubmit: (values, formikHelpers) => {

            const formData = new FormData();
            formData.append('doc_number', order.doc_number)

            for (let i = 0; i < photoUploadForm.length; i++) {
                const blob = photoUploadForm[i]?.blob;
                const name = photoUploadForm[i].name;
                const file = new File([blob], name);
                formData.append(`files[${i}][type]`, 'new');
                formData.append(`files[${i}][file]`, file);
            }

            for (let i = photoUploadForm.length; i < (photosFormOrder.length + photoUploadForm.length); i++) {
                const photo = photosFormOrder[i - photoUploadForm.length]
                formData.append(`files[${i}][type]`, 'old');
                formData.append(`files[${i}][file_id]`, photo.id.toString());
            }
            setLoading(true)
            coreService.uploadFiles(formData)
                .then(() => {
                    close()
                })
                .catch()
                .finally(() => {
                    setLoading(false)
                })
        }
    })

    useEffect(() => {
        if (order && order.urls.length) {
            setLoading(true)
            coreService.getPhotosByOrder(order.urls)
                .then(({data}) => {
                    setPhotosFromServer(data);
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [order]);

    const handleNumber = (codeNumber: string) => {
        formik.setFieldValue('number', codeNumber)

        if (codeNumber) {
            setOrder(null)
            coreService.getOrderList(codeNumber)
                .then(({data}) => {
                    if (data.list && Array.isArray(data.list) && data.list.length) {
                        setOrder(data.list[0]);
                    } else {
                        throw new Error(translate('order_not_found'));
                    }
                })
                .catch((reason) => {
                    setPhotosFromServer([])
                    toast(reason.toString(), {type: 'error'})
                })
        }
    }

    return {
        formik,
        handleNumber,
        order,
        photosFormOrder,
        setPhotoUploadForm,
        photoUploadForm,
        setPhotosFromServer,
    }
}

export default useCreatePhotoReport;
